import React from "react";
const wrapTextFormatter = (value) => {
  return (
    <span
      style={{
        wordWrap: "break-word",
        textAlign: "center",
      }}
    >
      {value || ""}
    </span>
  );
};
const monthFormatter = (val, month) => {
  return wrapTextFormatter(val[month] || "");
};
export const LogicValuesHeaderInfo = {
  sections: [
    {
      heights: { header1: "50px" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [
        { title: "Subdivision", colSpan: 13, rowSpan: 1, leftAlign: true, accessor: "subdivision", className: "tbl-text-normal" },
        { title: "Year", colSpan: 13, rowSpan: 1, leftAlign: true, accessor: "year", className: "tbl-text-normal" },
      ],
    },
    {
      heights: { header1: "50px" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [
        { title: "Mileage", colSpan: 13, rowSpan: 1, accessor: "milepost", leftAlign: true, className: "tbl-text-normal" },
        { title: "Location Name", colSpan: 13, rowSpan: 1, accessor: "location", leftAlign: true, className: "tbl-text-normal" },
      ],
    },
    {
      heights: { header1: "50px" },
      classes: { header1: "" },
      inlineBodyData: true,
      columns: [
        { title: "", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Jan", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Feb", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Mar", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Apr", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "May", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Jun", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Jul", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Aug", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Sep", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Oct", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Nov", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
        { title: "Dec", colSpan: 2, rowSpan: 1, isTitleOnly: true, className: "tbl-text-normal" },
      ],
    },
  ],
};
export const Logic_Values_Header_Schema = [
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Ballast Conditions",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
      },
      {
        title: "Jan",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "Feb",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "Mar",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "Apr",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "May",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "June",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "July",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "Aug",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "Sep",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "Oct",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "Nov",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "Dec",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 11),
      },
    ],
  },
];

export const Logic_Unit_Values_Schema = [
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Ballast Condition",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "ballast",
        formatter: (val) => monthFormatter(val, 12),
      },
    ],
  },
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Normal RX/EZ",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalRX",
        formatter: (val) => monthFormatter(val, 12),
      },
    ],
  },
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Normal PH",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "normalPH",
        formatter: (val) => monthFormatter(val, 12),
      },
    ],
  },
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Standby RX/EZ",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyRX",
        formatter: (val) => monthFormatter(val, 12),
      },
    ],
  },
  {
    heights: { header1: "50px", header2: "50px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Standby PH",
        colSpan: 2,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "",
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 1),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 2),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 3),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 4),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 5),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 6),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 7),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 8),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 9),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 10),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 11),
      },
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        isValueOnly: true,
        className: "tbl-text-normal",
        dontJoinValues: true,
        accessor: "standbyPH",
        formatter: (val) => monthFormatter(val, 12),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/Columbia/Columbia Site/logic_Unit_Values_Schema.jsx